export const isEmpty = (data: any) => data === null || data === undefined;
